import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/authContext";

const AuthRedirect = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // If the user is not authenticated, return the children (this would typically be the login page)
    return children;
  }

  // Check if there's a previous page (`state.from`)
  const redirectTo =
    location.state?.from ||
    (user?.role?.includes("customer") ? "/" : "/orders");

  // Redirect based on roles or the previous page
  return <Navigate to={redirectTo} />;
};

export default AuthRedirect;
